import styled from "styled-components";

export const OrderListWrapper = styled.div``;

export const OrderListPaginationWrapper = styled.div`
  margin-top: 40px;
`;
